<template>
  <div>
    <div class="row">
      <!-- En modo "solo informe de turnos" (restriccion 84) no hay breadcrumb: no hay adonde volver -->
      <breadcrumb v-if="!soloTurnos">
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>
          {{ $t("turnosDeOperarios") }}
        </template>
      </breadcrumb>
      <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv"
        :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" :conFiltrarPorFecha="true"
        :activarVolver="true" :cargando="isSearching" @consultar="emitirConsulta" @consultarVolver="volver" />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <!-- <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="changeNegocio()"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <label>&nbsp;</label>
              <div class="form-group">
                <button
                  v-if="!mostrarTurnos"
                  class="btn btn-primary"
                  @click="getSalesOperarios()"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="15"
                  />
                  {{ $t("consultar") }}
                </button>
                <button
                  v-else
                  class="btn btn-primary"
                  @click="turnosOperarios(idWorker)"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="15"
                  />
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <template v-else-if="respuesta">

        <div class="col-md-12 w-100">
          <div v-if="!hasSearched && !isSearching" class="alert mt-3 mb-3" style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
            {{ $t("hazClicConsultar") }}
          </div>
          <div v-if="isSearching" class="alert alert-warning mt-3 mb-3">
            <i class="fa fa-spinner fa-spin"></i> {{ $t("cargandoDatos") }}...
          </div>
        </div>

        <template v-if="hasSearched && !isSearching">
        <div class="col-md-8 order-2 order-md-1">
          <div v-if="!mostrarTurnos && list.length > 0" class="w-100 pb-3">
            <div class="d-flex justify-content-start align-items-center flex-wrap w-100" style="gap: 15px;">
              
              <el-dropdown>
                <el-button type="primary" size="small" style="margin: 0;">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdfSinDesglose") }}</strong>
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportPdfDesglosado">
                    <el-dropdown-item class="text-danger">
                      <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdfConDesglose") }}</strong>
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcelSinDesglose") }}</strong>
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcelDesglosado">
                    <el-dropdown-item class="text-success">
                      <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcelConDesglose") }}</strong>
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button v-if="!soloTurnos" type="success" size="small" @click="openModalExternalLink" style="margin: 0;">
                <i class="fa fa-share"></i>
                {{ $t("compartirEnlaceTurnos") }}
              </el-button>

              <div class="d-flex align-items-center mt-2 mt-md-0" style="gap: 10px; max-width: 100%;">
                <label class="mb-0" style="white-space: nowrap;"><strong>{{ $t("calculo") }}:</strong></label>
                
                <el-select class="select-default" v-model="metodoCalculo" size="small" @change="actualizarDatosCalculo" style="width: 135px; min-width: 115px;">
                  <el-option class="select-default" :label="$t('alMinuto')" value="minuto"></el-option>
                  <el-option class="select-default" :label="$t('redondear')" value="redondear"></el-option>
                  <el-option class="select-default" :label="$t('alSegundo')" value="exacto"></el-option>
                </el-select>

                <el-select 
                  v-if="metodoCalculo === 'redondear'" 
                  class="select-default" 
                  v-model="umbralRedondeo" 
                  size="small" 
                  @change="actualizarDatosCalculo" 
                  style="width: 145px; min-width: 130px;">
                  <el-option class="select-default" :label="$t('horaCompleta')" value="truncar"></el-option>
                  <el-option class="select-default" :label="$t('haciaArriba30m')" :value="30"></el-option>
                  <el-option class="select-default" :label="$t('haciaArriba45m')" :value="45"></el-option>
                </el-select>

                <span class="info-circle-icon ml-2"
                   data-toggle="modal" 
                   data-target="#modalInfoCalculo" 
                   :title="$t('verInfoCalculos')">i</span>
              </div>

            </div>
          </div>

          <template v-if="list.length > 0 && !mostrarTurnos">
            <div class="table-responsive">
              <table class="table table-bordered table-striped table-hover text-nowrap">
                <thead class="thead-dark">
                  <tr style="cursor: pointer">
                    
                    <th style="width: 40%;" v-if="ordenacionOperario === 0" @click="sortedArrayNameASC('workerName')">
                      {{ $t("nombre") }} <i style="color: white" class="fa fa-angle-up ml-1"></i>
                    </th>
                    <th style="width: 40%;" v-else @click="sortedArrayNameDESC('workerName')">
                      {{ $t("nombre") }} <i style="color: white" class="fa fa-angle-down ml-1"></i>
                    </th>

                    <th style="width: 20%;" class="text-right" v-if="ordenarDifHora === 0" @click="sortedArrayDifHoraASC('diffHora')">
                      {{ $t("horas") }} <i style="color: white" class="fa fa-angle-up ml-1"></i>
                    </th>
                    <th style="width: 20%;" class="text-right" v-else @click="sortedArrayDifHoraDESC('diffHora')">
                      {{ $t("horas") }} <i style="color: white" class="fa fa-angle-down ml-1"></i>
                    </th>

                    <th style="width: 15%;" class="text-right">{{ $t("tpPausas") }}</th>

                    <th style="width: 20%;" class="text-right" v-if="ordenarSueldo === 0" @click="sortedArraySueldoASC('import')">
                      {{ $t("sueldo") }} <i style="color: white" class="fa fa-angle-up ml-1"></i>
                    </th>
                    <th style="width: 20%;" class="text-right" v-else @click="sortedArraySueldoDESC('import')">
                      {{ $t("sueldo") }} <i style="color: white" class="fa fa-angle-down ml-1"></i>
                    </th>

                    <th style="width: 20%;" class="text-center">{{ $t("acciones") }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="obj in list" :key="obj.idWorker">
                    <td class="align-middle">{{ obj.name }}</td>
                    
                    <td class="text-right align-middle">
                  <span v-if="metodoCalculo === 'exacto'">
                    {{ obj.segundosExactos | formatoExactoConSegundos }}
                  </span>
                  <span v-else>
                    {{ obj.diffHora | formatoHoras }}
                    <span style="color: #999; font-size: 0.9em; margin-left: 5px; white-space: nowrap;">({{ obj.segundosExactos | formatoExactoSinSegundos }})</span>
                  </span>
                </td>
                    
                    <td class="text-right align-middle">
                      <span v-if="obj.pausasCount" class="tp-resumen-pausas" v-tooltip.top-center="textoPausasPorTipo(obj.pausasPorTipo)">
                        <i class="fas fa-pause-circle"></i> {{ obj.pausasCount }} · {{ formatSegCorto(obj.pausasSegundos) }}
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>

                    <td class="text-right align-middle">
                      <strong>{{ obj.importFinal | currency }}</strong>
                    </td>
                    
                    <td align="center" class="align-middle">
                      <div style="display: flex; justify-content: center; gap: 18px; font-size: 1.2em;">
                        <i @click="turnosOperarios(obj.idWorker)" 
                           class="fas fa-arrow-circle-right text-secondary" 
                           style="cursor: pointer; transition: transform 0.2s;"
                           onmouseover="this.style.transform='scale(1.2)'" 
                           onmouseout="this.style.transform='scale(1)'"
                           v-tooltip.top-center="$i18n.t('desgloseHorasTrabajadas')"></i>

                        <i @click="exportGestionTurnosOperariosPDF(obj.idWorker)" 
                           class="fas fa-file-pdf text-danger" 
                           style="cursor: pointer; transition: transform 0.2s;" 
                           onmouseover="this.style.transform='scale(1.2)'" 
                           onmouseout="this.style.transform='scale(1)'"
                           v-tooltip.top-center="'Exportar en PDF'"></i>

                        <i @click="exportGestionTurnosOperariosExcel(obj.idWorker)" 
                           class="fas fa-file-excel text-success" 
                           style="cursor: pointer; transition: transform 0.2s;"
                           onmouseover="this.style.transform='scale(1.2)'" 
                           onmouseout="this.style.transform='scale(1)'"
                           v-tooltip.top-center="'Exportar en Excel'"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
               <tr class="table-success">
                 <td class="align-middle">
                   <strong>{{ $t("total") }}</strong>
                 </td>

                 <td class="text-right align-middle">
                   <strong v-if="getTotalHoras !== 0">
                     <span v-if="metodoCalculo === 'exacto'">
                       {{ getTotalSegundosExactos | formatoExactoConSegundos }}
                     </span>
                     <span v-else>
                       {{ getTotalHoras | formatoHoras }}
                       <span style="color: #999; font-size: 0.85em; margin-left: 5px; white-space: nowrap; font-weight: normal;">({{ getTotalSegundosExactos | formatoExactoSinSegundos }})</span>
                     </span>
                   </strong>
                 </td>

                 <td class="text-right align-middle">
                   <strong v-if="totalPausasResumen.count">{{ totalPausasResumen.count }} · {{ formatSegCorto(totalPausasResumen.segundos) }}</strong>
                 </td>

                 <td class="text-right align-middle">
                   <strong v-if="getTotalSueldos !== 0">
                     {{ getTotalSueldos | currency }}
                   </strong>
                 </td>

                 <td></td>
               </tr>
             </tfoot>
              </table>
            </div>
          </template>
          <template v-else-if="mostrarTurnos">
            <div class="w-100 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap mb-3 w-100" style="gap: 15px;">
                
                <div class="d-flex align-items-center flex-wrap" style="gap: 15px;">
                  
                  <el-dropdown>
                    <el-button type="primary" size="small">
                      <i class="fa fa-file"></i>
                      {{ $t("exportarInforme") }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <a :href="urlExportPDFById">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i>
                            {{ $t("exportarPdf") }}</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="urlExportExcelById">
                        <el-dropdown-item class="text-success">
                          <strong>
                            <i class="fa fa-file-excel"></i>
                            {{ $t("exportarExcel") }}
                          </strong>
                        </el-dropdown-item>
                      </a>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <div class="d-flex align-items-center mt-2 mt-md-0" style="gap: 10px; max-width: 100%;">
                <label class="mb-0" style="white-space: nowrap;"><strong>{{ $t("calculo") }}:</strong></label>
                
                <el-select class="select-default" v-model="metodoCalculo" size="small" @change="actualizarDatosCalculo" style="width: 135px; min-width: 115px;">
                  <el-option class="select-default" :label="$t('alMinuto')" value="minuto"></el-option>
                  <el-option class="select-default" :label="$t('redondear')" value="redondear"></el-option>
                  <el-option class="select-default" :label="$t('alSegundo')" value="exacto"></el-option>
                </el-select>

                <el-select 
                  v-if="metodoCalculo === 'redondear'" 
                  class="select-default" 
                  v-model="umbralRedondeo" 
                  size="small" 
                  @change="actualizarDatosCalculo" 
                  style="width: 145px; min-width: 130px;">
                  <el-option class="select-default" :label="$t('horaCompleta')" value="truncar"></el-option>
                  <el-option class="select-default" :label="$t('haciaArriba30m')" :value="30"></el-option>
                  <el-option class="select-default" :label="$t('haciaArriba45m')" :value="45"></el-option>
                </el-select>

                <span class="info-circle-icon ml-2"
                   data-toggle="modal" 
                   data-target="#modalInfoCalculo" 
                   :title="$t('verInfoCalculos')">i</span>
              </div>

                </div>

                <div class="mt-2 mt-md-0">
                  <button @click="volver()" class="btn btn-primary btn-sm" style="background-color: #4a89f3; border-color: #4a89f3;">
                    <i class="fas fa-arrow-circle-left"></i>
                    {{ $t("volverAGeneral") }}
                  </button>
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center flex-wrap" style="gap: 10px;">
                <span style="font-size: 1.2em" v-if="listTurnos.length != 0">{{ $t("turnosDe") }} {{ listTurnos[0].name }}</span>
                <div class="btn-group btn-group-sm tp-vista" role="group">
                  <button type="button" :class="vistaDetalle === 'dias' ? 'btn btn-primary' : 'btn btn-outline-primary'" @click="vistaDetalle = 'dias'">
                    <i class="far fa-calendar-alt"></i> {{ $t("tpPorDias") }}
                  </button>
                  <button type="button" :class="vistaDetalle === 'turnos' ? 'btn btn-primary' : 'btn btn-outline-primary'" @click="vistaDetalle = 'turnos'">
                    <i class="fas fa-list"></i> {{ $t("tpPorTurnos") }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Vista por días: jornada del día (tramos), pausas por tipo y detalle desplegable -->
            <div class="w-100" v-if="vistaDetalle === 'dias'">
              <div class="table-responsive">
                <table class="table table-bordered table-hover text-nowrap tp-dias">
                  <thead class="thead-dark">
                    <tr>
                      <th style="width: 20%;">{{ $t("fecha") }}</th>
                      <th style="width: 24%;">{{ $t("tpHorario") }}</th>
                      <th style="width: 24%;">{{ $t("tpPausas") }}</th>
                      <th style="width: 14%;" class="text-right">{{ $t("horasTrabajadas") }}</th>
                      <th style="width: 13%;" class="text-right">{{ $t("sueldo") }}</th>
                      <th style="width: 5%;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="d in diasTurnos">
                      <tr :key="'d' + d.dia" class="tp-fila-dia" :class="{ 'tp-abierto': diasExpandidos[d.dia] }" @click="alternarDia(d.dia)">
                        <td class="align-middle tp-fecha">{{ d.fechaTexto }}</td>
                        <td class="align-middle">
                          <span v-for="(t, i) in d.turnos" :key="t.idWorkerDay" class="tp-tramo">
                            <span v-if="i > 0" class="tp-sep">·</span>
                            {{ horaUnix(t.initDate) }}–<strong v-if="parseInt(t.endDate) === 0" class="text-success">{{ $t("enActivo") }}</strong><template v-else>{{ horaUnix(t.endDate) }}</template>
                          </span>
                        </td>
                        <td class="align-middle">
                          <span v-if="d.porTipo.length" class="tp-chips">
                            <span v-for="g in d.porTipo" :key="g.type" class="tp-chip" :class="'tp-chip--' + g.type" :title="g.veces + ' × ' + etiquetaPausa(g.type)">
                              {{ etiquetaPausa(g.type) }} {{ formatSegCorto(g.segundos) }}
                            </span>
                          </span>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td class="text-right align-middle">
                          <span v-if="metodoCalculo === 'exacto'">{{ d.segundos | formatoExactoConSegundos }}</span>
                          <span v-else>{{ d.diffHora | formatoHoras }}</span>
                        </td>
                        <td class="text-right align-middle"><strong>{{ d.importFinal | currency }}</strong></td>
                        <td class="text-center align-middle">
                          <i class="fas" :class="diasExpandidos[d.dia] ? 'fa-chevron-up' : 'fa-chevron-down'" style="color: #888;"></i>
                        </td>
                      </tr>
                      <tr v-if="diasExpandidos[d.dia]" :key="'x' + d.dia" class="tp-fila-detalle">
                        <td colspan="6">
                          <ol class="tp-timeline">
                            <template v-for="t in d.turnos">
                              <li :key="'in' + t.idWorkerDay" class="tp-tl-item">
                                <span class="tp-tl-hora">{{ horaUnix(t.initDate) }}</span>
                                <span class="tp-tl-texto"><i class="fas fa-sign-in-alt"></i> {{ $t("entrada") }}</span>
                              </li>
                              <li v-for="p in t.pausas || []" :key="'p' + p.id" class="tp-tl-item tp-tl-pausa" :class="'tp-tl-pausa--' + p.type">
                                <span class="tp-tl-hora">{{ horaUnix(p.initDate) }}–{{ p.activa ? '…' : horaUnix(p.endDate) }}</span>
                                <span class="tp-tl-texto">
                                  <span class="tp-chip" :class="'tp-chip--' + p.type">{{ etiquetaPausa(p.type) }}</span>
                                  {{ formatSegCorto(p.segundos) }}<template v-if="p.activa"> · {{ $t("tpEnCurso") }}</template>
                                </span>
                              </li>
                              <li :key="'out' + t.idWorkerDay" class="tp-tl-item">
                                <span class="tp-tl-hora">{{ parseInt(t.endDate) === 0 ? '…' : horaUnix(t.endDate) }}</span>
                                <span class="tp-tl-texto">
                                  <i class="fas fa-sign-out-alt"></i>
                                  {{ parseInt(t.endDate) === 0 ? $t("enActivo") : $t("salida") }}
                                  <span class="text-muted">· {{ $t("tpTurnoDe") }} <template v-if="metodoCalculo === 'exacto'">{{ t.segundosExactos | formatoExactoConSegundos }}</template><template v-else>{{ t.diffHora | formatoHoras }}</template> · {{ t.importFinal | currency }}</span>
                                  <span class="tp-tl-acciones" @click.stop>
                                    <i v-if="t.observaciones !== ''" @click="(observacion = t.observaciones), openModal(t.idWorkerDay)" class="fas fa-edit text-warning" v-tooltip.top-center="$t('editarObservacion')"></i>
                                    <i v-else-if="!soloTurnos" @click="(observacion = ''), openModal(t.idWorkerDay)" class="fas fa-plus-circle text-success" v-tooltip.top-center="$t('anadirObservacion')"></i>
                                    <i v-if="!soloTurnos" @click="openModalEditarHora(t.idWorkerDay, t.initDate, t.endDate)" class="far fa-clock text-primary" v-tooltip.top-center="$t('editarHoraInicioYHoraFin')"></i>
                                    <i @click="openGeolocationModal(t.idWorker, t.initDate, t.endDate)" class="fas fa-map-marker-alt text-primary" v-tooltip.top-center="$t('verLocalizacionEnMapa')"></i>
                                  </span>
                                </span>
                              </li>
                              <li v-for="pr in paronesDespuesDe(d, t.idWorkerDay)" :key="'r' + t.idWorkerDay" class="tp-tl-item tp-tl-paron">
                                <span class="tp-tl-hora">{{ horaUnix(pr.inicio) }}–{{ horaUnix(pr.fin) }}</span>
                                <span class="tp-tl-texto"><i class="fas fa-arrows-alt-h"></i> {{ pr.partida ? $t("tpJornadaPartida") : $t("tpParon") }} · {{ formatSegCorto(pr.segundos) }}</span>
                              </li>
                            </template>
                          </ol>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr class="table-success">
                      <td class="align-middle"><strong>{{ $t("total") }}</strong> <span class="text-muted">({{ diasTurnos.length }} {{ $t("tpDias") }})</span></td>
                      <td></td>
                      <td class="align-middle"><strong v-if="totalPausasWorker.count">{{ totalPausasWorker.count }} · {{ formatSegCorto(totalPausasWorker.segundos) }}</strong></td>
                      <td class="text-right align-middle">
                        <strong v-if="getTotalHorasWorker !== 0">
                          <span v-if="metodoCalculo === 'exacto'">{{ getTotalSegundosExactosWorker | formatoExactoConSegundos }}</span>
                          <span v-else>{{ getTotalHorasWorker | formatoHoras }}</span>
                        </strong>
                      </td>
                      <td class="text-right align-middle"><strong>{{ getTotalSueldosWorker | currency }}</strong></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <p class="tp-nota"><i class="fas fa-info-circle"></i> {{ $t("tpNota") }}</p>
            </div>
            
            <div class="w-100" v-else>
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-hover text-nowrap">
                  <thead class="thead-dark">
                    <tr>
                      <th style="width: 18%;">{{ $t("horaInicio") }}</th>
                      <th style="width: 18%;">{{ $t("horaFin") }}</th>
                      <th style="width: 15%;" class="text-right">{{ $t("horasTrabajadas") }}</th>
                      <th style="width: 15%;">{{ $t("tpPausas") }}</th>
                      <th style="width: 15%;" class="text-right">{{ $t("sueldo") }}</th>
                      <th style="width: 14%;" class="text-center">{{ $t("observaciones") }}</th>
                      <th style="width: 20%;" class="text-center">{{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="t in listTurnos" :key="t.idWorkerDay">
                      <td class="align-middle">{{ t.initDate | parseDateMin }}</td>
                      
                      <td v-if="parseInt(t.endDate) === 0" class="text-success align-middle">
                        <strong>{{ $t("enActivo") }}</strong>
                      </td>
                      <td v-else class="align-middle">{{ t.endDate | parseDateMin }}</td>
                      
                      <td class="text-right align-middle">
                    <span v-if="metodoCalculo === 'exacto'">
                      {{ t.segundosExactos | formatoExactoConSegundos }}
                    </span>
                    <span v-else>
                      {{ t.diffHora | formatoHoras }}
                      <span style="color: #999; font-size: 0.9em; margin-left: 5px; white-space: nowrap;">({{ t.segundosExactos | formatoExactoSinSegundos }})</span>
                    </span>
                  </td>
                      <td class="align-middle">
                        <span v-if="(t.pausas || []).length" class="tp-chips" v-tooltip.top-center="textoPausasTurno(t.pausas)">
                          <span v-for="g in pausasPorTipo(t.pausas)" :key="g.type" class="tp-chip" :class="'tp-chip--' + g.type">
                            {{ etiquetaPausa(g.type) }} {{ formatSegCorto(g.segundos) }}
                          </span>
                        </span>
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="text-right align-middle"><strong>{{ t.importFinal | currency }}</strong></td>
                      
                      <td class="text-center align-middle">
                        <span v-if="t.observaciones === ''" class="text-danger"><strong>{{ $t("noMayuscula") }}</strong></span>
                        <span v-else class="text-success"><strong>{{ $t("siMayuscula") }}</strong></span>
                      </td>
                      
                      <td align="center" class="align-middle">
                        <!-- Contenedor Flexbox para agrupar los iconos -->
                        <div style="display: flex; justify-content: center; gap: 15px; font-size: 1.2em;">
                          <template v-if="t.observaciones !== ''">
                            <i @click="(observacion = t.observaciones), openModal(t.idWorkerDay)"
                               style="cursor: pointer; transition: transform 0.2s;"
                               onmouseover="this.style.transform='scale(1.2)'" 
                               onmouseout="this.style.transform='scale(1)'"
                               v-tooltip.top-center="$t('editarObservacion')"
                               class="fas fa-edit text-warning"></i>
                          </template>
                          <!-- Solo turnos: puede leer la observacion existente, no crearla ni editarla -->
                          <template v-else-if="!soloTurnos">
                            <i @click="(observacion = ''), openModal(t.idWorkerDay)"
                               style="cursor: pointer; transition: transform 0.2s;"
                               onmouseover="this.style.transform='scale(1.2)'" 
                               onmouseout="this.style.transform='scale(1)'"
                               v-tooltip.top-center="$t('anadirObservacion')"
                               class="fas fa-plus-circle text-success"></i>
                          </template>

                          <i v-if="!soloTurnos" @click="openModalEditarHora(t.idWorkerDay, t.initDate, t.endDate)"
                             style="cursor: pointer; transition: transform 0.2s;"
                             onmouseover="this.style.transform='scale(1.2)'" 
                             onmouseout="this.style.transform='scale(1)'"
                             v-tooltip.top-center="$t('editarHoraInicioYHoraFin')"
                             class="far fa-clock text-primary"></i>

                          <i @click="openGeolocationModal(t.idWorker, t.initDate, t.endDate)"
                             style="cursor: pointer; transition: transform 0.2s;"
                             onmouseover="this.style.transform='scale(1.2)'" 
                             onmouseout="this.style.transform='scale(1)'"
                             v-tooltip.top-center="$t('verLocalizacionEnMapa')"
                             class="fas fa-map-marker-alt text-primary"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-success">
                      <td class="align-middle">
                        <strong>{{ $t("total") }}</strong>
                      </td>
                      <td></td>
                      <td class="text-right align-middle">
                    <strong v-if="getTotalHorasWorker !== 0">
                      <span v-if="metodoCalculo === 'exacto'">
                        {{ getTotalSegundosExactosWorker | formatoExactoConSegundos }}
                      </span>
                      <span v-else>
                        {{ getTotalHorasWorker | formatoHoras }}
                        <span style="color: #999; font-size: 0.85em; margin-left: 5px; white-space: nowrap; font-weight: normal;">({{ getTotalSegundosExactosWorker | formatoExactoSinSegundos }})</span>
                      </span>
                    </strong>
                  </td>
                      <td class="align-middle"><strong v-if="totalPausasWorker.count">{{ totalPausasWorker.count }} · {{ formatSegCorto(totalPausasWorker.segundos) }}</strong></td>
                      <td class="text-right align-middle"><strong>{{ getTotalSueldosWorker | currency }}</strong></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="alert alert-danger" role="alert">
              {{ $t("noHay") }} <strong>{{ $t("ventasPorOperarios") }}</strong>
              {{ $t("rangoDeFechas") }}
            </div>
          </template>
        </div>

        <div class="col-md-4 order-1 order-md-2" v-show="list.length > 0">
            <div class="card" style="overflow-x: auto; overflow-y: hidden;">
              
              <div class="chart-container grafica-responsive" 
                   :style="{ 
                     position: 'relative', 
                     width: '100%', 
                     minWidth: mostrarTurnos ? (listTurnos.length * 25) + 'px' : (list.length * 40) + 'px' 
                   }">
                <canvas id="chart"></canvas>
              </div>
              
            </div>
          </div>
        </template>
      </template>
    </div>

    <modal name="modal-agregar-observacion" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ soloTurnos ? $t("observaciones") : $t("anadirObservacion") }}</h4>
        </div>
        <div class="modal-body">
          <label for="observacion"><strong>{{ $t("observaciones") }}</strong></label>
          <textarea style="height: 300px" v-model="observacion" class="form-control" id="observacion" :readonly="soloTurnos">
      </textarea>
        </div>
        <div class="modal-footer" v-if="!soloTurnos">
          <div align="right" class="col-12">
            <button @click="changeObservaciones" class="btn btn-success">
              <i class="fas fa-plus-circle"></i>
              {{ $t("anadirObservacion") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-editar-horario" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarHorario") }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label><strong>{{ $t("fechaInicio") }}</strong></label>
            <datetime zone="Europe/Madrid" :auto="true" type="datetime" class="theme-numier" :title="$t('fechaInicio')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="dd-MM-yyyy HH:mm"
              v-model="fechaInicio"></datetime>
          </div>

          <div class="form-group">
            <label><strong>{{ $t("fechaFin") }}</strong></label>
            <datetime zone="Europe/Madrid" :auto="true" type="datetime" class="theme-numier" :title="$t('fechaFin')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="dd-MM-yyyy HH:mm"
              v-model="fechaFin"></datetime>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="changeHorarioTurno" class="btn btn-primary">
              <i class="fas fa-history"></i>
              {{ $t("editarHorarioDeTurno") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal external link turnos🔥 -->
    <modal name="modal-external-link" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("enlaceExternoTurnosTitle") }}</h4>
        </div>
        <div class="modal-body">
          <label><strong>{{ $t("enlaceExternoTurnosLabel") }}</strong>
          </label>

          <div class="input-group mb-3">
            <input type="text" class="form-control"
              :value="`https://www.numier.com/online/#/informes/operarios/turnos-operarios-external-link/${generatedHash}`"
              readonly />
            <button class="btn btn-outline-secondary"
              @click="copyToClipboard(`https://www.numier.com/online/#/informes/operarios/turnos-operarios-external-link/${generatedHash}`)">
              <i class="fas fa-copy"></i>
            </button>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="$modal.hide('modal-external-link')">
              <strong>{{ $t("cerrar") }}</strong>
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-geolocation" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
      @opened="renderMap">
      <div style="width: 100%; height: 500px">
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("geolocalizacionJornada") }}</h4>
        </div>
        <div class="modal-body">
          <div id="map" style="width: 100%; height: 400px"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="$modal.hide('modal-geolocation')">
            {{ $t("cerrar") }}
          </button>
        </div>
      </div>
    </modal>

    <div class="modal fade" id="modalInfoCalculo" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header text-white" style="background-color: #447DF7;">
            <h5 class="modal-title" style="color: white;"><strong><i class="fa fa-info-circle"></i> {{ $t("infoCalculoTurnosTitulo") }}</strong></h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="font-size: 1.05em; color: #333;">
            <p>{{ $t("infoCalculoIntroP1") }} <strong>{{ $t("infoCalculoIntroDestacado") }}</strong>.</p>

            <ul class="list-group mb-3">
              <li class="list-group-item">
                <strong>{{ $t("infoCalculoAlMinutoTitulo") }}</strong><br>
                {{ $t("infoCalculoAlMinutoDesc") }} <strong>1h 30m</strong>. {{ $t("infoCalculoAlMinutoSueldo") }}
              </li>
              <li class="list-group-item">
                <strong>{{ $t("infoCalculoRedondearTitulo") }}</strong><br>
                {{ $t("infoCalculoRedondearDesc") }}
                <ul>
                  <li><strong>{{ $t("horaCompleta") }}:</strong> {{ $t("infoCalculoHoraCompletaDesc") }} <strong>1h</strong>.</li>
                  <li><strong>{{ $t("haciaArriba30m") }} / {{ $t("haciaArriba45m") }}:</strong> {{ $t("infoCalculoHaciaArribaDesc") }}</li>
                </ul>
                <em class="text-danger">{{ $t("infoCalculoRedondearNota") }}</em>
              </li>
              <li class="list-group-item">
                <strong>{{ $t("infoCalculoAlSegundoTitulo") }}</strong><br>
                {{ $t("infoCalculoAlSegundoDesc1") }} <strong>1h 30m 45s</strong>{{ $t("infoCalculoAlSegundoDesc2") }}
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("entendido") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Loading,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import { mapState } from 'vuex'
import { Modal } from "bootstrap";
import { ModalPlugin } from "bootstrap-vue";

export default {
  data() {
    return {
      isSearching: false,
      hasSearched: false,
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      idBusiness: 0,
      list: ["-"],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      idTpv: 0,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenacionOperario: 0,
      ordenarImporte: 0,
      ordenarInvitations: 0,
      ordenarDifHora: 0,
      ordenarSueldo: 0,

      observacion: "",

      //TURNOS
      mostrarTurnos: false,
      listTurnos: [],
      idWorker: 0,

      idWorkerDay: 0,
      respuesta: true,
      filtrarPorFecha: false,

      fechaInicio: new Date().toISOString(),
      fechaFin: new Date().toISOString(),

      createdDate: new Date().toISOString(),
      expiredDate: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(), // +5 horas
      generatedHash: "",

      geolocationCoords: null,
      activarVolver: false,
      metodoCalculo: 'minuto',
      umbralRedondeo: 'truncar',

      // Pausas (app de gestión de turnos): vista del desglose y días desplegados
      vistaDetalle: 'dias',
      diasExpandidos: {}
    };
  },
  computed: {
    ...mapState(["permiso", "soloTurnos"]),

    /**
     * Desglose del operario agrupado por días: tramos del día (jornada partida), pausas por tipo,
     * parones entre turnos y totales. Las pausas son informativas: no cambian horas ni sueldo.
     */
    diasTurnos() {
      const porDia = {};
      this.listTurnos.forEach((t) => {
        const dia = moment.unix(t.initDate).format("YYYY-MM-DD");
        (porDia[dia] = porDia[dia] || []).push(t);
      });

      return Object.keys(porDia)
        .sort()
        .map((dia) => {
          const turnos = porDia[dia].slice().sort((a, b) => a.initDate - b.initDate);
          const pausas = [];
          const parones = [];
          turnos.forEach((t, i) => {
            (t.pausas || []).forEach((p) => pausas.push(p));
            const sig = turnos[i + 1];
            if (sig && parseInt(t.endDate) > 0) {
              const segundos = sig.initDate - t.endDate;
              if (segundos > 0) {
                parones.push({ despuesDe: t.idWorkerDay, inicio: t.endDate, fin: sig.initDate, segundos, partida: segundos >= 3600 });
              }
            }
          });
          const fechaTexto = moment.unix(turnos[0].initDate).format("dddd, DD/MM/YYYY");
          return {
            dia,
            fechaTexto: fechaTexto.charAt(0).toUpperCase() + fechaTexto.slice(1),
            turnos,
            parones,
            porTipo: this.pausasPorTipo(pausas),
            diffHora: turnos.reduce((acc, t) => acc + (t.diffHora || 0), 0),
            segundos: turnos.reduce((acc, t) => acc + (t.segundosExactos || 0), 0),
            importFinal: Math.round(turnos.reduce((acc, t) => acc + (t.importFinal || 0), 0) * 100) / 100,
          };
        });
    },
    totalPausasWorker() {
      let count = 0;
      let segundos = 0;
      this.listTurnos.forEach((t) => {
        (t.pausas || []).forEach((p) => {
          count++;
          segundos += p.segundos || 0;
        });
      });
      return { count, segundos };
    },
    totalPausasResumen() {
      let count = 0;
      let segundos = 0;
      (Array.isArray(this.list) ? this.list : []).forEach((o) => {
        count += o.pausasCount || 0;
        segundos += o.pausasSegundos || 0;
      });
      return { count, segundos };
    },
    getTotalSueldos() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.importFinal || 0;
      });
      return Math.round(total * 100) / 100;
    },
    getTotalHoras() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    getTotalHorasWorker() {
      let total = 0;
      this.listTurnos.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    getTotalSegundosExactos() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.segundosExactos || 0;
      });
      return total;
    },
    getTotalSegundosExactosWorker() {
      let total = 0;
      this.listTurnos.forEach(function (d) {
        total += d.segundosExactos || 0;
      });
      return total;
    },
    getTotalSueldosWorker() {
      let total = 0;
      this.listTurnos.forEach(function (d) {
        total += d.importFinal || 0;
      });
      return Math.round(total * 100) / 100;
    },
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },

    urlExportPdfDesglosado() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersDesglosado/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },

    urlExportExcelDesglosado() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersDesglosado/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },

    urlExportPDFById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/PDF?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },
    urlExportExcelById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt +
        "&metodoCalculo=" + this.metodoCalculo +
        "&umbralRedondeo=" + this.umbralRedondeo
      );
    },
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("turnosDeOperarios"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    CabeceraInformes,
    Breadcrumb,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  filters: {
    formatoHoras(valor) {
      if (!valor) return "0h";
      let horas = Math.floor(valor / 60);
      let minutos = Math.round(valor % 60);
      if (minutos === 0) return horas + "h";
      return horas + "h " + minutos + "m";
    },
    formatoExactoConSegundos(segundos) {
      if (!segundos) return "0h";
      let h = Math.floor(segundos / 3600);
      let m = Math.floor((segundos % 3600) / 60);
      let s = Math.round(segundos % 60);
      let res = "";
      if (h > 0) res += h + "h ";
      if (m > 0 || h > 0) res += m + "m ";
      res += s + "s";
      return res.trim();
    },
    formatoExactoSinSegundos(segundos) {
      if (!segundos) return "0h";
      let h = Math.floor(segundos / 3600);
      let m = Math.round((segundos % 3600) / 60);
      if (m === 60) { h += 1; m = 0; }
      if (h === 0 && m === 0) return "0m";
      if (h === 0) return m + "m";
      if (m === 0) return h + "h";
      return h + "h " + m + "m";
    }
  },
  methods: {
    // ---- Pausas ----
    etiquetaPausa(tipo) {
      const claves = { desayuno: "tpDesayuno", cigarro: "tpCigarro", descanso: "tpDescanso", otra: "tpOtra" };
      return this.$t(claves[tipo] || "tpOtra");
    },
    formatSegCorto(segundos) {
      const min = Math.floor((segundos || 0) / 60);
      const h = Math.floor(min / 60);
      const m = min % 60;
      return h > 0 ? h + "h " + String(m).padStart(2, "0") + "m" : m + "m";
    },
    horaUnix(ts) {
      return moment.unix(ts).format("HH:mm");
    },
    pausasPorTipo(pausas) {
      const orden = ["desayuno", "cigarro", "descanso", "otra"];
      const mapa = {};
      (pausas || []).forEach((p) => {
        const tipo = orden.includes(p.type) ? p.type : "otra";
        mapa[tipo] = mapa[tipo] || { type: tipo, segundos: 0, veces: 0 };
        mapa[tipo].segundos += p.segundos || 0;
        mapa[tipo].veces++;
      });
      return orden.filter((t) => mapa[t]).map((t) => mapa[t]);
    },
    textoPausasPorTipo(porTipo) {
      return (porTipo || []).map((g) => this.etiquetaPausa(g.type) + " " + this.formatSegCorto(g.segundos) + " (" + g.veces + ")").join(" · ");
    },
    textoPausasTurno(pausas) {
      return (pausas || [])
        .map((p) => this.etiquetaPausa(p.type) + " " + this.horaUnix(p.initDate) + "–" + (p.activa ? "…" : this.horaUnix(p.endDate)) + " (" + this.formatSegCorto(p.segundos) + ")")
        .join(" · ");
    },
    alternarDia(dia) {
      this.$set(this.diasExpandidos, dia, !this.diasExpandidos[dia]);
    },
    paronesDespuesDe(dia, idWorkerDay) {
      return dia.parones.filter((p) => p.despuesDe === idWorkerDay);
    },

    formatDate(dateStr) {
      const date = new Date(parseInt(dateStr) * 1000);
      return date.toLocaleString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    cambioBusiness(idBusinessData, listTpv = null) {
      this.idBusiness = idBusinessData;
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.idTpv = -1;
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },
    emitirConsulta(filtrarPorFecha) {
      this.getSalesOperarios(filtrarPorFecha);
    },
    cambioTpv(idTpvData, filtrarPorFecha) {
      this.idTpv = idTpvData;

      if (this.idWorker != 0 && this.mostrarTurnos == true) {
        //this.turnosOperarios(this.idWorker);
        this.mostrarTurnos = false;
      }
      //this.getSalesOperarios(filtrarPorFecha);
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    actualizarDatosCalculo() {
      this.ejecutarConsultaCalculo();
    },

    ejecutarConsultaCalculo() {
      if (this.mostrarTurnos) {
        this.turnosOperarios(this.idWorker); 
      } else {
        this.getSalesOperarios(this.filtrarPorFecha);
      }
    },
    sortedArrayWorkerDay: function () {
      function compare(a, b) {
        if (a.initDate < b.initDate) return -1;
        if (a.initDate > b.initDate) return 1;
        return 0;
      }

      return this.listTurnos.sort(compare);
    },

    openModal(idWorkerDay) {
      this.$modal.show("modal-agregar-observacion");

      this.idWorkerDay = idWorkerDay;
    },

    openModalEditarHora(idWorkerDay, initDate, endDate) {
      this.$modal.show("modal-editar-horario");

      this.idWorkerDay = idWorkerDay;

      this.fechaInicio = moment.unix(initDate).toISOString();

      if (endDate !== "0") {
        this.fechaFin = moment.unix(endDate).toISOString();
      } else {
        this.fechaFin = new Date().toIsoString();
      }
    },

    sortedArrayNameASC: function () {
      this.ordenacionOperario = 1;

      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayNameDESC: function () {
      this.ordenacionOperario = 0;

      function compare(a, b) {
        if (a.name > b.name) return -1;
        if (a.name < b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayDifHoraASC: function () {
      this.ordenarDifHora = 1;

      function compare(a, b) {
        if (a.diffHora < b.diffHora) return -1;
        if (a.diffHora > b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayDifHoraDESC: function () {
      this.ordenarDifHora = 0;

      function compare(a, b) {
        if (a.diffHora > b.diffHora) return -1;
        if (a.diffHora < b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArraySueldoASC: function () {
      this.ordenarSueldo = 1;

      function compare(a, b) {
        if (a.import < b.import) return -1;
        if (a.import > b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArraySueldoDESC: function () {
      this.ordenarSueldo = 0;

      function compare(a, b) {
        if (a.import > b.import) return -1;
        if (a.import < b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    turnosOperarios(idWorker) {
      this.idWorker = idWorker;

      this.mostrarTurnos = true;

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idTpv: this.idTpv,
              idBusiness: this.idBusiness,
              idWorker: idWorker,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
              filtrarFecha: this.filtrarPorFecha,
              skipCambioHora: 0,
              metodoCalculo: this.metodoCalculo,
              umbralRedondeo: this.umbralRedondeo
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "workers/getWorkersDay", config)
            .then(function (response) {
              if (response.data.response) {
                vm.listTurnos = response.data.result;
                vm.sortedArrayWorkerDay();

                vm.$nextTick(() => {
                  vm.initChartWorker();
                });
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },

    openGeolocationModal(idWorker, initDate, endDate) {

      this.idWorker = idWorker;
      this.initDate = initDate;
      this.endDate = endDate;

      const config = {
        params: {
          datefrom: initDate,
          dateto: endDate,
          idWorker: idWorker,
          jwt: this.$store.getters.jwt,
        },
        headers: {
          Authorization: "Bearer " + this.$store.getters.jwt
        },
      };

      this.axios
        .get(this.$store.getters.apiUrl + "workers/getGeolocationByWorkerDay", config)
        .then((response) => {
          if (response.data.response && response.data.coords) {
            this.geolocationCoords = response.data.coords;
            this.$modal.show("modal-geolocation");
          } else {
            this.$notify({
              message: this.$t("noSeHaEncontradoLocalizacion"),
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.$notify({
            message: this.$t("errorAlObtenerLocalizacion"),
            type: "danger",
          });
        });
    },

    renderMap() {
      const mapElement = document.getElementById("map");
      if (!mapElement) {
        console.warn("No se encontró el div #map");
        return;
      }

      const coords = this.geolocationCoords;
      if (
        !coords ||
        !coords.start_shift ||
        coords.start_shift.latitude == null ||
        coords.start_shift.longitude == null
      ) {
        return;
      }

      // Marcador defaulto de Google Maps
      // http://maps.google.com/mapfiles/ms/icons/blue-dot.png
      // Custom paddle iconos de Google Maps
      // https://maps.google.com/mapfiles/kml/paddle/blu-blank.png

      const startIcon = {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        scaledSize: new google.maps.Size(40, 40),
      };

      const endIcon = {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: new google.maps.Size(40, 40),
      };

      const startLatLng = {
        lat: parseFloat(coords.start_shift.latitude),
        lng: parseFloat(coords.start_shift.longitude),
      };

      const map = new google.maps.Map(mapElement, {
        center: startLatLng,
        zoom: 15,
      });

      // const startInfo = new google.maps.InfoWindow({
      //   content: `
      //     <div>
      //       <strong>Trabajador: ${(this.listTurnos.length > 0 && this.listTurnos[0].name) ? this.listTurnos[0].name : this.$t("trabajador")}</strong><br/>
      //       ${this.$t("inicioJornada")}<br/>
      //       ${this.formatDate(this.initDate)}<br/>
      //       Lat: ${startLatLng.lat.toFixed(5)}, Lng: ${startLatLng.lng.toFixed(5)}
      //     </div>
      //   `
      // });

      const startInfo = new google.maps.InfoWindow({
        content: `
          <div style="
            font-family: 'Segoe UI', Arial, sans-serif;
            min-width: 240px;
            padding: 0px 12px 12px 12px;
            border-radius: 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
            background: #fff;
            color: #333;
          ">
            <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px; margin-left: -2px;">
              <i class="fas fa-user-circle" style="font-size: 1.4em; color: #3F51B5;"></i>
                <span style="font-weight: 600; font-size: 1.1em;">
                Trabajador: ${(this.listTurnos.length > 0 && this.listTurnos[0].name) ? this.listTurnos[0].name : this.$t("trabajador")}
                </span>
            </div>
            <hr style="border: none; border-top: 1px solid #eee; margin: 8px 0;" />
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
              <i class="fas fa-play-circle" style="color: #2196F3;"></i>
              <span style="color: #2196F3; font-weight: 500;">${this.$t("inicioJornada")}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
              <i class="far fa-calendar-alt" style="color: #666;"></i>
              <span>${this.formatDate(this.geolocationCoords.initDate)}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <i class="fas fa-map-marker-alt" style="color: #E53935;"></i>
              <span><strong>Lat:</strong> ${startLatLng.lat.toFixed(5)}, <strong>Lng:</strong> ${startLatLng.lng.toFixed(5)}</span>
            </div>
          </div>
        `
      });


      const startMarker = new google.maps.Marker({
        position: startLatLng,
        map,
        title: this.$t("inicioJornada"),
        icon: startIcon,
      });

      startMarker.addListener("click", () => {
        startInfo.open(map, startMarker);
      });

      if (
        coords.end_shift &&
        coords.end_shift.latitude != null &&
        coords.end_shift.longitude != null
      ) {
        let endLatLng = {
          lat: parseFloat(coords.end_shift.latitude),
          lng: parseFloat(coords.end_shift.longitude),
        };

        // Detectar si están en el mismo lugar
        const sameLocation =
          startLatLng.lat === endLatLng.lat && startLatLng.lng === endLatLng.lng;

        if (sameLocation) {
          // Aplicar offset mínimo para evitar solapamiento (aprox. 5 metros)
          endLatLng = {
            lat: endLatLng.lat + 0.00005,
            lng: endLatLng.lng + 0.00005,
          };
        }

        // const endInfo = new google.maps.InfoWindow({
        // content: `
        //   <div>
        //     <strong>Trabajador: ${(this.listTurnos.length > 0 && this.listTurnos[0].name) ? this.listTurnos[0].name : this.$t("trabajador")}</strong><br/>
        //     ${this.$t("finJornada")}<br/>
        //     ${this.formatDate(this.endDate)}<br/>
        //     Lat: ${startLatLng.lat.toFixed(5)}, Lng: ${startLatLng.lng.toFixed(5)}
        //   </div>
        // `
        // });

        const endInfo = new google.maps.InfoWindow({
          content: `
            <div style="
              font-family: 'Segoe UI', Arial, sans-serif;
              min-width: 240px;
              padding: 0px 12px 12px 12px;
              border-radius: 10px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.15);
              background: #fff;
              color: #333;
            ">
              <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px; margin-left: -2px;">
                <i class="fas fa-user-circle" style="font-size: 1.4em; color: #3F51B5;"></i>
                <span style="font-weight: 600; font-size: 1.1em;">
                  ${(this.listTurnos.length > 0 && this.listTurnos[0].name) ? this.listTurnos[0].name : this.$t("trabajador")}
                </span>
              </div>
              <hr style="border: none; border-top: 1px solid #eee; margin: 8px 0;" />
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
                <i class="fas fa-stop-circle" style="color: #F44336;"></i>
                <span style="color: #F44336; font-weight: 500;">${this.$t("finJornada")}</span>
              </div>
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
                <i class="far fa-calendar-alt" style="color: #666;"></i>
                <span>${this.formatDate(this.geolocationCoords.endDate)}</span>
              </div>
              <div style="display: flex; align-items: center; gap: 8px;">
                <i class="fas fa-map-marker-alt" style="color: #E53935;"></i>
                <span><strong>Lat:</strong> ${endLatLng.lat.toFixed(5)}, <strong>Lng:</strong> ${endLatLng.lng.toFixed(5)}</span>
              </div>
            </div>
          `
        });

        const endMarker = new google.maps.Marker({
          position: endLatLng,
          map,
          title: this.$t("finJornada"),
          icon: endIcon,
        });

        endMarker.addListener("click", () => {
          endInfo.open(map, endMarker);
        });

        // Dibujar línea curva geodésica entre los puntos de inicio y fin
        // const path = new google.maps.Polyline({
        //   path: [startLatLng, endLatLng],
        //   geodesic: true,
        //   strokeColor: "#FFA500",
        //   strokeOpacity: 0.9,
        //   strokeWeight: 5,
        // });

        // path.setMap(map);

        const bounds = new google.maps.LatLngBounds();
        bounds.extend(startLatLng);
        bounds.extend(endLatLng);
        map.fitBounds(bounds);
      }
    },

    changeNegocio() { },

    volver() {
      this.listTurnos = [];
      this.mostrarTurnos = false;

      this.getSalesOperarios(this.filtrarPorFecha);
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
            vm.idTpv = -1;
          }
          //vm.cambioTpv(-1, false)
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((_) => {
          this.loading.close();
        });
    },
    getSalesOperarios(filtrarPorFecha) {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.isSearching = true;
          this.hasSearched = false;

          this.mostrarTurnos = false;
          this.listTurnos = [];

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              filtrarPorFecha: filtrarPorFecha,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
              desde: 0,
              metodoCalculo: this.metodoCalculo,
              umbralRedondeo: this.umbralRedondeo
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "workers/getTurnosOperarios",
              config
            )
            .then(function (response) {
              if (response.data.response) {
                vm.list = response.data.result;
                vm.respuesta = true;
                vm.filtrarPorFecha = filtrarPorFecha;
                
                vm.hasSearched = true;
                vm.isSearching = false;

                vm.$nextTick(() => {
                  vm.initChart();
                });

              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
                vm.hasSearched = true;
              }
            })
            .catch(function (error) {
              console.log(error);
              vm.hasSearched = true;
            })
            .finally(() => {
              vm.isSearching = false;
            });
        }
      }
    },

    changeObservaciones() {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };
      var params = {
        observaciones: this.observacion,
        idWorkerDay: this.idWorkerDay,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateObservacionesByIdWorkerDay";
      this.axios
        .post(
          this.$store.getters.apiUrl + "workers/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {
            let notify = vm.$t("actualizada");
            vm.$notify({
              message:
                vm.$t("observacion") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.turnosOperarios(vm.idWorker);

            vm.$modal.hide("modal-agregar-observacion");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    changeHorarioTurno() {
      let secondsDesde = moment(this.fechaInicio).unix();
      let secondsHasta = moment(this.fechaFin).unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };
        var params = {
          datefrom: secondsDesde,
          dateto: secondsHasta,
          idWorkerDay: this.idWorkerDay,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "updateHorarioByIdWorkerDay";
        this.axios
          .post(
            this.$store.getters.apiUrl + "workers/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("actualizada");
              vm.$notify({
                message:
                  vm.$t("observacion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.turnosOperarios(vm.idWorker);

              vm.$modal.hide("modal-editar-horario");
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    exportGestionTurnosOperariosExcel(idWorker) {
      // window.location.href = "../api/public/index.php/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&idWorker=" + idWorker + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;

      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
          "&filtrarPorFecha=" +
    this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt;
    },
    exportGestionTurnosOperariosPDF(idWorker) {
      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/PDF?idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
          "&filtrarPorFecha=" +
          this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt;
    },

    initChart() {
      var labels = this.list.map(function (x) {
        return x.name;
      });

      var data = this.list.map(function (x) {
        var hours = Math.floor(x.diffHora / 60);
        var minutes = Math.floor(x.diffHora % 60);

        return hours + minutes / 100;
      });

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador === 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "bar",
            data: {
              labels: labels,
              datasets: [
                {
                  label: this.$t("horasTrabajadas"),
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },

              responsive: true,
              maintainAspectRatio: false,
            },
          });

          this.contador++;
        }
      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                label: this.$t("turnosOperarios"),
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }
    },

    initChartWorker() {
      // Sacamos las fechas de los turnos para la parte de abajo (eje X)
      var labels = this.listTurnos.map(function (x) {
        return moment.unix(x.initDate).format("DD/MM/YYYY");
      });

      // Sacamos las horas trabajadas para la altura de las barras (eje Y)
      var data = this.listTurnos.map(function (x) {
        var hours = Math.floor(x.diffHora / 60);
        var minutes = Math.floor(x.diffHora % 60);
        return hours + minutes / 100;
      });

      // Le damos color a las barras
      var randomColor = require("randomcolor");
      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
      });

      // Si ya existía una gráfica, la destruimos para no superponerlas
      if (this.objectChart !== null) {
        this.objectChart.destroy();
      }

      // Pintamos la gráfica nueva
      this.objectChart = new Chart("chart", {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: this.$t("horasTrabajadas"),
              data: data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
              maxBarThickness: 30,
            },
          ],
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      });
    },
    openModalExternalLink() {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      var params = {
        idBusiness: this.idBusiness,
        idTpv: this.idTpv,
        createdDate: Math.floor(Date.now() / 1000), // Timestamp actual en segundos
        datefrom: moment(this.datefrom).startOf("day").unix(),
        dateto: moment(this.dateto).endOf("day").unix(),
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "generateExternalLinkTurnosOperarios";
      //this.loading = Loading.service({ text: "Cargando..." });
      //vm.loading.close();

      this.axios
        .post(
          this.$store.getters.apiUrl + "workers/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.success) {
            vm.generatedHash = response.data.hash;
            vm.$modal.show("modal-external-link");

            vm.$notify({
              message: vm.$t("enlaceGeneradoExito"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("ups"),
              text: vm.$t("noSeHaPodidoGenerarElEnlace"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.error("Error al generar el enlace externo:", error);

          swal({
            title: vm.$t("ups"),
            text: vm.$t("errorComunicacionBackend"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$notify({
          title: this.$t("enlaceCopiadoAlPortapapeles"),
          horizontalAlign: "center",
          type: "success",
        });
      });
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.textNumier {
  color: #1E22AA;
}

.ms-xs {
  margin-left: 0.1rem;
}
.info-circle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #447DF7;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  font-family: Georgia, serif;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s;
  user-select: none;
}
.info-circle-icon:hover {
  background-color: #2a5fd4;
}
.grafica-responsive {
  height: 375px; 
}

/* ---- Pausas (app de gestión de turnos) ---- */
.tp-vista .btn {
  margin: 0;
}
.tp-resumen-pausas {
  color: #b45309;
  white-space: nowrap;
  cursor: default;
}
.tp-chips {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}
.tp-chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.8em;
  font-weight: 600;
  white-space: nowrap;
}
.tp-chip--desayuno { color: #92400e; background: #fef3c7; }
.tp-chip--cigarro { color: #374151; background: #e5e7eb; }
.tp-chip--descanso { color: #115e59; background: #ccfbf1; }
.tp-chip--otra { color: #5b21b6; background: #ede9fe; }
.tp-fila-dia {
  cursor: pointer;
}
.tp-fila-dia.tp-abierto > td {
  background: #eef2ff;
}
.tp-fecha {
  font-weight: 600;
}
.tp-tramo {
  white-space: nowrap;
}
.tp-sep {
  margin: 0 6px;
  color: #999;
  font-weight: 700;
}
.tp-fila-detalle > td {
  background: #fafbfc;
  padding: 6px 12px 12px;
}
.tp-timeline {
  list-style: none;
  margin: 0 0 0 14px;
  padding: 6px 0 6px 20px;
  border-left: 2px solid #dfe3ea;
}
.tp-tl-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 5px 0;
}
.tp-tl-item::before {
  content: "";
  position: absolute;
  left: -27px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #1e22aa;
  border: 2px solid #fafbfc;
}
.tp-tl-pausa {
  padding-left: 16px;
}
.tp-tl-pausa::before {
  width: 10px;
  height: 10px;
  left: -26px;
  background: #fbbf24;
}
.tp-tl-pausa--cigarro::before { background: #9ca3af; }
.tp-tl-pausa--descanso::before { background: #14b8a6; }
.tp-tl-pausa--otra::before { background: #8b5cf6; }
.tp-tl-paron {
  margin: 4px 0;
  padding: 6px 10px;
  border-radius: 6px;
  background: #f1f3f7;
  color: #666;
}
.tp-tl-paron::before {
  background: #b6bcc8;
}
.tp-tl-hora {
  min-width: 105px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.tp-tl-texto {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.tp-tl-acciones {
  display: inline-flex;
  gap: 12px;
  margin-left: 10px;
  font-size: 1.05em;
}
.tp-tl-acciones i {
  cursor: pointer;
}
.tp-nota {
  font-size: 0.85em;
  color: #777;
}

@media (max-width: 768px) {
  .grafica-responsive {
    height: 280px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/TurnosOperarios.vue